import { useTranslation } from 'react-i18next';
import type { ContentStatus } from './statuses';
import type { Role } from '@shared/rbac/permissions.const';

/**
 * Hooks that resolve shared enum labels via the `common` namespace. Replaces the
 * old static `*_LABEL` dictionaries so no user-facing text is hardcoded. The enum
 * keys (CONTENT_STATUS, ROLE, …) and color maps stay where they were.
 */
function useLooseT(): (key: string) => string {
  const { t } = useTranslation('common');
  return t as unknown as (key: string) => string;
}

export function useContentStatusLabel(): (status: ContentStatus) => string {
  const t = useLooseT();
  return (status) => t(`contentStatus.${status}`);
}

export function useRoleLabel(): (role: Role) => string {
  const t = useLooseT();
  return (role) => t(`roles.${role}`);
}
